import PropTypes from 'prop-types';

import { PICKUP_DATE, DROPOFF_DATE } from '../consts';

const carSharingPoint = PropTypes.shape({
  name: PropTypes.string,
  key: PropTypes.string,
});

const CarGeoAutocompleteNextPoint = PropTypes.shape({
  actualValue: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    code: PropTypes.string,
    key: PropTypes.string,
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const CarsSearchFormPropTypes = {
  isTest: PropTypes.bool,
  suggest: PropTypes.shape({
    pickUp: CarGeoAutocompleteNextPoint,
    dropOff: CarGeoAutocompleteNextPoint,
  }).isRequired,
  search: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  lang: PropTypes.string,
  initialPickUpPoint: carSharingPoint,
  initialDropOffPoint: carSharingPoint,
  className: PropTypes.string,
  fieldNames: PropTypes.arrayOf(PropTypes.string),
  [PICKUP_DATE]: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
  }),
  [DROPOFF_DATE]: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
  }),
  history: PropTypes.shape({}), // NOTE: Объект history из React Router Dom
  change: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
};
